// Omni PG 切替画面のラベル
export const LABELS = {
  APPLICATION_FILE: "切替用ファイル",
  FILE_PLACEHOLDER: "アップロード対象ファイル",
  NO: "No",
  ERROR_DETAIL: "エラー内容",
  ERROR_TITLE: "提出ファイルエラー内容",
  ERROR_TEXT_LABEL: "まだファイルはアップロードされていません。",
} as const;

export const CONFIGS = {
  FILE: "file",
  FILE_EXTENSION: ".xlsx",
  UPLOAD_TYPE: "uploadType",
  APPLICATION_FILE: "切替用ファイル",
} as const;

export const CONTENTS = {
  APPLICATION_FILE_NAME: "\r\n・切替用ファイル\r\n　　ファイル名：{0}",
} as const;
